module.exports = __webpack_public_path__ + "img/banner_04.084184c3.jpg";